module.exports = __webpack_public_path__ + "static/media/Underdark.012a1ebb.jpg";